// extracted by mini-css-extract-plugin
export var button = "_s6-1";
export var container = "_s6-0";